"use client";

import type { AuthMode } from "../hooks/useAuthForm";
import { InputField } from "../shared";

type AuthEmailFormProps = {
  mode: AuthMode;
  email: string;
  password: string;
  confirmPassword: string;
  loading: boolean;
  onEmailChange: (val: string) => void;
  onPasswordChange: (val: string) => void;
  onConfirmPasswordChange: (val: string) => void;
  onSubmit: (e: React.FormEvent) => void;
};

export function AuthEmailForm({
  mode,
  email,
  password,
  confirmPassword,
  loading,
  onEmailChange,
  onPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
}: AuthEmailFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-3.5">
      <InputField
        label="Email"
        name="email"
        type="email"
        placeholder="you@example.com"
        value={email}
        onChange={onEmailChange}
        autoComplete="email"
      />
      <InputField
        label="Password"
        name="password"
        type="password"
        placeholder="••••••••"
        value={password}
        onChange={onPasswordChange}
        autoComplete={mode === "sign-in" ? "current-password" : "new-password"}
      />
      {mode === "sign-up" && (
        <InputField
          label="Confirm password"
          name="confirm_password"
          type="password"
          placeholder="••••••••"
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
          autoComplete="new-password"
        />
      )}

      <button
        type="submit"
        disabled={loading}
        className={[
          "w-full rounded-xl px-4 py-2.5 text-[15px] font-semibold transition-all duration-200",
          "bg-[#4c9cd5] text-[#0a0f15] hover:bg-[#5aa9de] active:bg-[#3d8ac2]",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          "mt-1",
        ].join(" ")}
      >
        {loading
          ? "Please wait..."
          : mode === "sign-in"
            ? "Sign in"
            : "Create account"}
      </button>
    </form>
  );
}
